<template>
    <div v-bind:class="['BaseButtonFlat',className,accent ? 'BaseButtonFlat_accent' : '']" @click="click($event.target)">
        {{translate(label)}}
    </div>
</template>

<script>
    export default {
        name: 'BaseButtonFlat',
        props: {
            //Text on the button
            label: {
                type: String,
                required: true
            },
            //The button will have bright color if you will set to true this property
            accent: {
                type: Boolean
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        },
        methods: {
            click: function (e) {
                this.$emit('click', e);
            }
        }
    };
</script>

<style>
    .BaseButtonFlat {
        background: transparent;
        min-width: 64px;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 500;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
        text-transform: uppercase;
        color: rgba(0,0,0,.87);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer
    }

        .BaseButtonFlat.disabled {
            pointer-events: none;
            color: rgba(0,0,0,.2)
        }

    .BaseButtonFlat_accent {
        color: #00bcd4
    }
</style>



// WEBPACK FOOTER //
// BaseButtonFlat.vue?5893024a